import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "row g-5 g-xl-8"
}
const _hoisted_2 = {
  key: 0,
  class: "col-xl-4 align-self-start"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MatchinPayReload = _resolveComponent("MatchinPayReload")
  const _component_MatchinPayHistory = _resolveComponent("MatchinPayHistory")

  return (_ctx.ccode === 0 && _ctx.pt !== 'bibo' && _ctx.pt !== 'ecc')
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        (!_ctx.isOverriden)
          ? (_openBlock(), _createBlock("div", _hoisted_2, [
              _createVNode(_component_MatchinPayReload, { "widget-classes": "mb-5 mb-xxl-8" })
            ]))
          : _createCommentVNode("", true),
        _createVNode("div", {
          class: _ctx.isOverriden ? 'col-xl-12' : 'col-xl-8'
        }, [
          _createVNode(_component_MatchinPayHistory, { "widget-classes": "card-xxl-stretch mb-5 mb-xxl-8" })
        ], 2)
      ]))
    : _createCommentVNode("", true)
}